module.exports = __webpack_public_path__ + "static/media/intro-video-captions-en.c0b86b58.vtt";